import React, { forwardRef } from 'react'
import CalendarIcon from 'Assets/Images/calendar.png'
import './DateInput.scss'

const DateInput = forwardRef(({ value, onClick, error }: any, ref: any) => (
  <div
    className={`form-control d-flex justify-content-between align-items-center ${
      error ? 'is-invalid' : ''
    }`}
    onClick={onClick}
    ref={ref}
  >
    <span className='value'>{value || 'Select date & time'}</span>

    <span className='calendar-icon'>
      <img src={CalendarIcon} alt='icon' />
    </span>
  </div>
))

DateInput.displayName = 'DateInput'

export default DateInput
